import {ICompanySettings, InternalPdfFieldType, ITemplate, TriggerEntity, UserPreferDateFormatType} from '@core/api/data-access';
import {LanguageType} from '@shared-types';
import {BE} from '@utils';
import {Policy} from '../types';
import {CompanyLogo} from './company-logo.model';

import BESchema = BE.BESchema;
import BEProp = BE.BEProp;

@BESchema()
export class CompanySettingsModel implements ICompanySettings {
	@BEProp() defaultLanguage: LanguageType;
	@BEProp() defaultFlatten: boolean;
	@BEProp() defaultAllowAlert: boolean;
	@BEProp() rejectPolicy: Policy;
	@BEProp() commentPolicy: Policy;
	@BEProp() addNameToSignatures: boolean;
	@BEProp() addTimestampToSignatures: boolean;
	@BEProp() addJobTitleToSignatures: boolean;
	@BEProp() useSplashScreen: boolean;
	@BEProp() companyLogo: CompanyLogo;
	@BEProp() allowDownloadAfterSign: boolean;
	@BEProp() daysToReminder: number;
	@BEProp() defaultReminderDays: number;
	@BEProp() enableReminders: boolean;
	@BEProp() predictorTrust: number;
	@BEProp() phonePrefix: string;
	@BEProp() daysToArchive: number;
	@BEProp() defaultAgentCode: string;
	@BEProp() daysToExpireNonApprove: number;
	@BEProp() defaultEmailRecipient: string;
	@BEProp() autoApproveCycle: boolean; // sign in click
	@BEProp() autoRemarks: boolean; // show add comment automatically
	@BEProp() autoCamera: boolean; // show camera automatically
	@BEProp() fieldFillerAuto: boolean; // show form filler automatically on mobile
	@BEProp() fieldFillerHiddenTypes: InternalPdfFieldType[]; // hide fields in form filler
	@BEProp() defaultTriggers: TriggerEntity[];
	@BEProp() smsAccountSid: string;
	@BEProp() smsAccountName: string;
	@BEProp() emailSenderName: string;
	@BEProp() smsTwilioSid: string;
	@BEProp() wawbInstanceId: string;
	@BEProp() smsTemplates: ITemplate[];
	@BEProp() waTemplates: ITemplate[];
	@BEProp() moduleIdentityVerification: string;

	@BEProp() htmlTemplates: ITemplate[];
	@BEProp() daysToExpireApprove: number;
	@BEProp() defaultCancelDays: number;

	@BEProp() emailTemplates: ITemplate[];
	/**
	 * 0 - not allowed to keep an original document
	 * >	0 - allowed to keep an original document
	 */
	@BEProp() keepOriginalDocument: number;
	@BEProp() postalAccount: string;
	@BEProp() defaultDateFormat: UserPreferDateFormatType;
	@BEProp() imageCompression: number;

	@BEProp() gtmId: string;
	@BEProp() showSeparateRejectButton: boolean;

	constructor(init?: ObjectTypes.Of<CompanySettingsModel | ICompanySettings>) {
		if (init) Object.assign(this, init);
		if (init?.companyLogo && !(init?.companyLogo instanceof CompanyLogo)) this.companyLogo = new CompanyLogo(init.companyLogo);
	}
}
